import React, { useState, useEffect } from "react";

import { useStore } from "../../../Store";
import PageLayout, { PageLayoutWithGetData } from "../../Controls/PageLayout";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Center,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  Image,
  Input,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";

export default function OneTimePassword() {
  const navigate = useNavigate();
  const toast = useToast();

  const { selectedDataHolderBrand } = useStore();

  const [otp, setOtp] = useState("");
  const [disableContinueButton, setDisableContinueButton] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const [invalidOtp, setInvalidOtp] = useState(false);

  useEffect(() => {
    var validOpt = /^\d{6}$/;

    setInvalidOtp(false);

    if (otp.match(validOpt)) {
      setDisableContinueButton(false);
      setShowWarning(false);
    } else {
      setDisableContinueButton(true);
      if (otp === "") {
        setShowWarning(false);
      } else {
        setShowWarning(true);
      }
    }
  }, [otp]);

  function OnclickContinue() {
    if (otp !== "123456") {
      toast({
        title: "Please provide a valid OTP! e.g 123456",
        status: "error",
        duration: 4000,
        isClosable: true,
        position: "top",
      });

      setInvalidOtp(true);
    } else {
      navigate("/SelectAccounts");
    }
  }

  return (
    <PageLayoutWithGetData
      loading={false}
      backgroundColor={selectedDataHolderBrand?.backgroundColor}
      isMockBankScreen={true}
      hasContainerPadding={false}
    >
      <Box px={10} py={5}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!disableContinueButton) {
              OnclickContinue();
            }
          }}
        >
          <Center mt={4} mb={4}>
            <Image
              shadow="lg"
              maxH="300px"
              maxW="300px"
              borderRadius="xl"
              src={selectedDataHolderBrand?.logoUri}
              alt={selectedDataHolderBrand?.brandName + " Logo"}
            />
          </Center>
          <Heading mt={4} variant="pageHeading">
            One time Password
          </Heading>

          <VStack spacing={3} alignItems="baseline">
            <Text>
              Accredited consumer data rights Recipients will never ask for your
              bank's password
            </Text>

            <Text>
              A One time Password has been sent to your mobile *******190 to
              securely connect to {selectedDataHolderBrand?.brandName}.
            </Text>
            <Text fontWeight="bold">Please enter this below.</Text>
          </VStack>

          <FormControl isInvalid={invalidOtp} mt={3} mb={5}>
            <FormLabel fontWeight="bold">One Time Password</FormLabel>
            <Input
              autoFocus
              id="txtCustomerId"
              bg="white"
              type="number"
              placeholder="Enter the 6 digit One time Password"
              value={otp}
              aria-label="Enter the 6 digit One time Password."
              onChange={(val) => setOtp(val.target.value)}
            />
            {showWarning && (
              <FormHelperText color="black.200">
                One Time Password must be exactly 6 digits
              </FormHelperText>
            )}

            {invalidOtp && (
              <FormErrorMessage>
                Incorrect One Time Password. Please try again
              </FormErrorMessage>
            )}
          </FormControl>

          <Center>
            <Button
              colorScheme="blue"
              disabled={disableContinueButton}
              id="btnContinue"
              data-testid="btnContinue"
              aria-label="Continue Button"
              mt={3}
              mb={6}
              variant="primary"
              w="190px"
              h="48px"
              onClick={OnclickContinue}
            >
              Continue
            </Button>
          </Center>
        </form>
      </Box>
    </PageLayoutWithGetData>
  );
}
